import { render, staticRenderFns } from "./DocumentLibrariesConfig.vue?vue&type=template&id=581a1dd2&"
import script from "./DocumentLibrariesConfig.vue?vue&type=script&lang=js&"
export * from "./DocumentLibrariesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports